import "./edit-package.scss";

import ErrorSection from "@shared/ui/error-section/error-section";
import HeaderButton from "@shared/ui/header-button/header-button";
import HeaderContent from "@shared/ui/header-content/header-content";
import SkeletonList from "@shared/ui/skeleton-list/skeleton-list";
import { ConfirmDialog } from "primereact/confirmdialog";
import { TabMenu, TabMenuTabChangeEvent } from "primereact/tabmenu";
import { useState } from "react";
import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Outlet, useNavigate, useParams } from "react-router-dom";

import FormPackage from "../form-package/form-package";
import { useEditPackage } from "./edit-package.hook";

export function EditPackage() {
  const navigate = useNavigate();
  const [tabActiveIndex, setTabActiveIndex] = useState(0);
  const { packageId } = useParams();
  const {
    packageData,
    isLoading,
    packageError,
    formMethod,
    actions,
    handleBack,
    handleAction,
  } = useEditPackage();

  const items = [
    { label: "Activities", icon: "pi pi-file-edit" },
    { label: "Transport", icon: "pi pi-chart-line" },
    { label: "Accommodation", icon: "pi pi-chart-line" },
  ];

  const handleTabChange = (e: TabMenuTabChangeEvent) => {
    switch (e.index) {
      case 0:
        navigate(`../${packageId}`);
        break;
      case 1:
        navigate(`/business/package/${packageId}/package-transport`);
        break;
      case 2:
        navigate(`/business/package/${packageId}/package-accommodation`);
        break;
    }

    setTabActiveIndex(e.index);
  };

  const title = packageData?.name ? (
    <h1>{packageData?.name}</h1>
  ) : (
    <h1>Edit Package</h1>
  );
  const displayLoading = (
    <div className="card">
      <SkeletonList count={4} />
    </div>
  );
  const displayError = (
    <div className="card">
      <ErrorSection
        title="No Data"
        message="No data found in selected record. Please try again."
      />
    </div>
  );
  const mainContent = (
    <div>
      <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
        <FormPackage />
        <div>
          <TabMenu
            model={items}
            activeIndex={tabActiveIndex}
            onTabChange={handleTabChange}
          />
          <Outlet />
        </div>
      </section>
    </div>
  );

  return (
    <div id="EditPackage" className="package">
      <HeaderContent
        title={title}
        backIcon={<FaChevronLeft />}
        onBack={() => handleBack()}
      >
        <HeaderButton actions={actions} onAction={handleAction} />
      </HeaderContent>

      <section className="p-7">
        <ConfirmDialog />
        <FormProvider {...formMethod}>
          {isLoading && displayLoading}
          {packageError && !isLoading && displayError}
          {!isLoading ? mainContent : null}
        </FormProvider>
      </section>
    </div>
  );
}

export default EditPackage;
